import React from "react";
import '../styles/Success.css';
import payment from '../assets/images/success-image.png';
const Success = (props) => {
    return (
        <div className="success-component animate">
            <div className="image-container-success">
                <img src={payment} alt="success" />
            </div>
            <div className="main-text">
                Thank You
            </div>
            <div className="sub-text">
                For your valuable feedback.
            </div>
            <div className="patient-detail">
                <div>Your feedback has been saved against your MRN.</div>
                <div className="bold">{props.patient.mrn+' - '+props.patient.patient_name}</div>
            </div>
        </div>
    )
}
export default Success;